/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Equipment,
  EquipmentParams,
  Equipments,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Equipment list
 */
export const equipment = (
    params?: MaybeRefOrGetter<EquipmentParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Equipments>(
      {url: `/equipment`, method: 'GET',
        params, signal
    },
      );
    }




export const getEquipmentQueryKey = (params?: MaybeRefOrGetter<EquipmentParams>,) => {
    return [
    'equipment', ...(params ? [params] : [])
    ] as const;
    }


export const getEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof equipment>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<EquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipment>>> = ({ signal }) => equipment(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>
}

export type EquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof equipment>>>
export type EquipmentQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Equipment list
 */

export function useEquipment<TData = Awaited<ReturnType<typeof equipment>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<EquipmentParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipment>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Equipment detail
 */
export const equipmentItem = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Equipment>(
      {url: `/equipment/${slug}`, method: 'GET', signal
    },
      );
    }




export const getEquipmentItemQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'equipment',slug
    ] as const;
    }


export const getEquipmentItemQueryOptions = <TData = Awaited<ReturnType<typeof equipmentItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItem>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getEquipmentItemQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof equipmentItem>>> = ({ signal }) => equipmentItem(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof equipmentItem>>, TError, TData>
}

export type EquipmentItemQueryResult = NonNullable<Awaited<ReturnType<typeof equipmentItem>>>
export type EquipmentItemQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Equipment detail
 */

export function useEquipmentItem<TData = Awaited<ReturnType<typeof equipmentItem>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof equipmentItem>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getEquipmentItemQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






